import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BooleanSearchInput } from "@similarweb/ui-components";

const { red, blue, bluegrey, carbon, midnight } = colorsPalettes;

export const InputWrapper = styled.div`
    position: relative;
    text-align: center;
    z-index: 1;
`;

export const StyledInput = styled(BooleanSearchInput)<{ isError: boolean; isDisabled: boolean }>`
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);

    width: 100%;

    border-radius: 3px;
    padding: 12px 16px;
    box-sizing: border-box;
    border: 1px solid ${midnight[50]};
    ${setFontVariant("input2", carbon[400])};

    ${({ isError, isDisabled }) => {
        if (isError) {
            return css`
                border: 1px solid ${red["400_P"]};
            `;
        }

        if (isDisabled) {
            return css`
                border: 1px solid ${carbon[200]};
                background: ${bluegrey[200]};
                cursor: not-allowed;
            `;
        }
    }}

    &:focus {
        border: ${({ isError }) => (isError ? `1px solid ${red["400_P"]}` : `1px solid ${blue[400]}`)};
    }
`;

export const NameError = styled.p`
    position: absolute;
    bottom: -20px;

    text-align: start;
    margin: 0;
    ${setFontVariant("input2", red["400_P"])};
`;

export const IconWrapper = styled.div`
    position: absolute;
    top: 8px;
    right: 16px;
`;
